import { faImage } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Spinner } from '@kcftech/design-system';
import { IPictureFileMetadataResponse } from '@kcftech/prometheustypescriptapiclient';
import { AuthorizedImage } from 'components/image/AuthorizedImage';
import { ArrowLink } from 'components/link/ArrowLink';
import styled from 'styled-components';
import { KCFColor } from 'styles/themes/KCFColor';
import { Environment } from 'utils/EnvironmentHelper';
import { appendToRoute, getLocationFileLibraryBaseRoute } from 'utils/RouteHelper';

const Thumbnail = styled(AuthorizedImage)`
    height: auto;
    max-height: 48px;
    width: 48px;
    max-width: 48px;
    margin-right: 10px;
`;

export type FileData = Pick<
    IPictureFileMetadataResponse,
    'Id' | 'DisplayName' | 'FileName' | 'ThumbnailFileName'
> & {
    LocationId: string | undefined;
};

// Construct the URL to obtain files from S3
export const getFileThumbnailUrl = (picture: FileData) =>
    `${Environment.apiBaseUrl}/api/v3.0/Files/object/${picture.ThumbnailFileName}`;

export type ImageFileNameCellProps = Readonly<{
    fileData: FileData;
    enableModal: boolean;
    url: string;
}>;

export function ImageFileNameCell({
    fileData,
    enableModal,
    url,
}: ImageFileNameCellProps) {
    return (
        <>
            <Thumbnail
                src={getFileThumbnailUrl(fileData)}
                aria-label={`Thumbnail for ${fileData.DisplayName}`}
                alt={`Thumbnail for ${fileData.DisplayName}`}
                pending={<Spinner className="pr-15" />}
                imageScaling="contain"
                fallback={
                    <FontAwesomeIcon
                        icon={faImage}
                        color={KCFColor.mediumGrey5}
                        title="Image"
                        aria-label="Image"
                        size="3x"
                        className="mr-10"
                    />
                }
            />
            <ArrowLink
                to={
                    // To navigate to the settings/FileLibrary from the modal, we must obtain the route
                    enableModal
                        ? getLocationFileLibraryBaseRoute(
                              fileData.LocationId ?? '',
                              fileData.Id
                          )
                        : appendToRoute(url, fileData.Id)
                }
                target={enableModal ? '_blank' : ''}
                rel={enableModal ? 'noreferrer noopener' : ''}
            >
                <div
                    className={`${
                        enableModal ? 'max-cell-width-modal' : 'max-cell-width'
                    } ellipsis-1-line`}
                    title={fileData.DisplayName}
                >
                    {fileData.DisplayName}
                </div>
            </ArrowLink>
        </>
    );
}
